import React, { useState, useEffect, useRef } from 'react';
import StorageManager from '../context/StorageManager';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Link, useParams, useNavigate} from 'react-router-dom';
import { useProvider, Toast } from '../context/MenuProvider';
import RenderizarItem from '../components/Utils/RenderizarProduto';
import AOS from "aos";
import 'aos/dist/aos.css';


const Config = () => {
    const navigate = useNavigate();
    const {
      hasPerms,
      hasPermsAnd,
      setTitle,
    } = useProvider();
    
    useEffect(()=>{
      setTitle("Configurações");
    }, [])
    
    
    useEffect(() => {
        // Inicialize o AOS para as animações, caso esteja usando isso
        AOS.init({
          duration: 1000,
          easing: "ease-in-out",
          once: true,
          mirror: false,
        });
    }, []);
    
    const menuItems = [
      { to: "/config/funcoes", icon: "bx bx-slider", label: "Ativar/Desativar Funções", info: "Selecionar funções do App que deseja usar", perm: null },
      { to: "/config/atalhos", icon: "bx bx-dialpad-alt", label: "Acesso Rápido", info: "Configurar atalhos para acesso rápido das funções desejadas", perm:null },
      { to: "/config/push", icon: "bx bx-bell", label: "Notificações", info: "Configure as notificações que deseja receber", perm: ['core.view_pushmensagem'] },
      { to: "/integracao/whatsapp", icon: "bx bxl-whatsapp", label: "WhatsApp", info: "Conectar WhatsApp para envio de mensagens automático", perm: ['core.view_whatsappmensagem'] },
      //{ to: "/config", icon: "bx bx-calculator", label: "Juros e multa", info: "Configurar as taxas de juros e multas por atraso", perm: ['loja.view_juros'] },
      //{ to: "/config", icon: "bx bx-cycling", label: "Taxas de entrega", info: "Configurar taxas de entrega", perm: ['loja.view_entrega'] },
      { to: "/config/templates", icon: "bx bx-message-dots", label: "Templates de Mensagens", info: "Templates de mensagens para WhatsApp", perm: ['core.view_template'] },
      { to: "/integracao", icon: "bx bx-check-shield", label: "Conta Bancária", info: "Vincular conta bancária para receber pagamentos", perm: ['pagamento_online.view_configurarpagamento'] },
      { to: "/produtos/convite", icon: "bx bx-transfer-alt", label: "Sincronizar Estoque (A/B)", info: "Sincronizar escoque com outra conta do app", perm: ['loja.view_produtos'] },
      { to: "/produtos/parceiros", icon: "bx bx-box", label: "Catálogos de Parceiros", info: "Carregar estoque com produtos já cadastrados por parceiros", perm: ['loja.view_produtos'] },
      { to: "/painel/site", icon: "bx bx-globe", label: "Configurar App", info: "Configurar App do seu negócio", perm: ['loja.view_customsite'] },
      
      { to: "/config/backup", icon: "bx bx-data", label: "Backup automático", info: "Configurar o período backup de segurança dos dados e receba no email", perm: null },
      { to: "/painel/perfil", icon: "bx bx-user", label: "Perfil de Cadastro", info: "Editar perfil de cadastro", perm: null },
    ];
  
    const filteredItems = menuItems.filter(item => !item.perm || hasPermsAnd(item.perm));
  


    return (<>
      <div className="list-group">
        {filteredItems.map((item, index) => (
          <>
            <div data-aos="fade-up">
              <RenderizarItem 
                  to={item.to} 
                  icon={item.icon}
                  titulo={item.label} 
                  text2={item.info}
              />
            </div>
          </>
        ))}
      </div>
    </>)
};

export default Config;